import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { AddIcon } from "ui/gluestack/icon";
import { NoItemsComponent } from "ui/atoms/noItems";
import { CreateBodyMapEntryModal } from "../../../features/reporting/modals/CreateBodyMapEntryModal";
import { useRef, useState } from "react";
import { PermissionCheck } from "../../../features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "../../../services/api/types/authorisation/enums/PermissionsEnums";
import { Accordion } from "ui/gluestack/accordion";
import { useGetBodyMapEntries } from "../../../features/reporting/hooks/useGetBodyMapEntries";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { BodyMapEntryItem } from "../../../features/reporting/organisms/BodyMapEntryItem";
import { BodyMapEntryStatusEnums } from "../../../services/api/types/bodyMap/BodyMapEntryStatusEnums";
import Pagination from "ui/molecules/pagination/Pagination";

export function CurrentBodyMapEntriesScreen() {
  const ref = useRef<React.ComponentRef<typeof CreateBodyMapEntryModal>>(null);
  const handleShowModal = () => {
    ref.current?.show();
  };

  const [openItemId, setOpenItemId] = useState<string | undefined>();

  const { data, isLoading, handlePageChange } = useGetBodyMapEntries({
    entryStatus: BodyMapEntryStatusEnums.ONGOING,
  });

  return (
    <View className="resident-container">
      <View className="flex-row mb-4">
        <Text className="text-sm font-normal text-typography-500">
          Report any issue identified during the resident’s physical assessment.
          <br />
          Create a new entry for each different issue.
        </Text>
        <PermissionCheck permission={PermissionsEnums.CREATE_BODY_MAP_ENTRY}>
          <Button
            action="primary"
            size="sm"
            className="ml-auto"
            onPress={handleShowModal}
          >
            <ButtonIcon as={AddIcon} />
            <ButtonText className="text-xs sm:text-base">
              Report New Finding
            </ButtonText>
          </Button>
        </PermissionCheck>
      </View>
      <View>
        <View className="flex-column gap-3">
          {isLoading ? (
            <LoadingSpinner />
          ) : data?.data.length ? (
            <View>
              <Accordion
                type="single"
                variant="unfilled"
                className="mb-4 w-full"
                value={openItemId ? [openItemId] : []}
                onValueChange={(values) => {
                  setOpenItemId(values[0]);
                }}
              >
                {data?.data.map((entry) => (
                  <View key={entry.id} className="mb-3">
                    <BodyMapEntryItem
                      entry={entry}
                      isOpen={openItemId === entry.id.toString()}
                    />
                  </View>
                ))}
              </Accordion>
            </View>
          ) : (
            <NoItemsComponent
              className="py-5"
              title="No items!"
              subtitle="Click on the ‘Report New Finding’ button to log an issue."
            />
          )}
          <Pagination meta={data?.meta} onPageChange={handlePageChange} />
        </View>
      </View>
      <CreateBodyMapEntryModal ref={ref} />
    </View>
  );
}
